import { render, staticRenderFns } from "./DisclosureTriangle.vue?vue&type=template&id=74acfb36&scoped=true&"
import script from "./DisclosureTriangle.vue?vue&type=script&lang=js&"
export * from "./DisclosureTriangle.vue?vue&type=script&lang=js&"
import style0 from "./DisclosureTriangle.vue?vue&type=style&index=0&id=74acfb36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74acfb36",
  null
  
)

export default component.exports